export const MIN_FIELD_LENGTH = 3;
export const MAX_FIELD_LENGTH = 20;

export const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,-.\\\/:;<=>?@[\]^_`{|}~])(?=.{8,})/;
export const latinAndSpaceRegexp = /^[a-zA-ZàáâäãåąæčćęèéêëėįìíîïłńòóôöõøþùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČÐĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÞÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,. '’-]+$/;
export const latinAndNumbersRegexp = /^[a-zA-Z0-9]*$/;
